import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  background: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1rem auto;
  max-width: 1200px;
  text-align: center;

  h3 {
    color: #856404;
    margin-top: 0;
  }

  p {
    color: #856404;
    font-size: 0.95rem;
  }
`;

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('ErrorBoundary caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorContainer>
          <h3>⚠️ Something went wrong</h3>
          <p>An error occurred while loading this section. Please refresh the page or try again later.</p>
          <p style={{ fontSize: '0.85rem', color: '#999' }}>
            {this.state.error?.message}
          </p>
        </ErrorContainer>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
